<template>
  <main style="opacity: 0;">
    <div class="block">
      <Paragraph
        size="small"
        :text="structure[0].eyelet"
        class="block__eyelet"
        data-anim="fade"
        data-view="false"
      />
      <Counter
        number="04"
        data-anim="fade"
        data-view="false"
      />
      <div data-nav="contatti">
        <Title
          size="big"
          :text="structure[0].title"
          data-anim="title"
          data-view="false"
          data-siblings
        />
      </div>

      <div class="block__content">
        <Paragraph
          :size="structure[0].textSize"
          :text="structure[0].text"
          data-anim="fade"
          data-view="false"
        />
      </div>
      <div class="block__social">
        <div class="block__social__children">
          <Title
            size="small"
            :text="structure[1].leftTitle"
            data-anim="title"
            data-view="false"
          />
          <div
            class="block__social__line"
            data-anim="line"
            data-view="false"
          />
          <Paragraph
            size="small"
            :text="structure[1].leftText"
            data-anim="stagger-fade"
            data-view="false"
          />
        </div>
        <div class="block__social__children">
          <Title
            size="small"
            :text="structure[1].rightTitle"
            data-anim="title"
            data-view="false"
          />
          <div
            class="block__social__line"
            data-anim="line"
            data-view="false"
          />
          <Paragraph
            size="small"
            :text="structure[1].rightText"
            data-anim="stagger-fade"
            data-view="false"
          />
        </div>
      </div>
      <div class="block__form">
        <Form />
      </div>
    </div>
  </main>
</template>

<script>
import Counter from '@/components/text/Counter.vue';
import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';
import Form from '@/components/Form.vue';

export default {
  name: 'Contact',

  components: {
    Counter,
    Title,
    Paragraph,
    Form,
  },

  computed: {
    structure() {
      const data = this.$store.state.firebase.contatti;
      const { lang } = this.$store.state;
      const structure = data.structure[lang];
      const s = [];
      Object.keys(structure).forEach((key) => {
        s.push(Object.assign(structure[key].data, {
          component: this.$store.state.settings.components[structure[key].component].component
        }));
      });
      return s;
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  & + .block {
    margin-top: rem(80px);
  }

  &__eyelet {
    margin-bottom: rem(70px);
  }

  &__content {
    p {
      max-width: 50%;
      margin-top: rem(100px);
    }
  }

  &__social {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    padding-top: rem(100px);

    &__children {
      flex: 0 0 100%;
      padding-bottom: 40px;

      @include mq(ipadP) {
        flex: 0 0 50%;
        flex-basis: calc(50% - #{rem(60px)});
        max-width: calc(50% - #{rem(60px)});
        padding-bottom: 0px;
      }

      & ::v-deep p {
        margin: 0;
      }
    }

    &__line {
      position: relative;
      width: 100%;
      height: 1px;

      margin: rem(15px) 0 rem(30px) 0;

      background: $color-dark-light;
    }
  }

  &__notes {
    padding-top: rem(100px);
    p {
      margin-top: rem(60px);
    }
  }
}
</style>
